module.exports = __webpack_public_path__ + "img/premium-yield-none.f6754f1c.svg";